import React, { useRef } from 'react';
import Tablenization from '@icoach/components/Tablenization';
import { RemitAllowanceVoidDialog } from '@icoach/accountBook/dialog';
import { rowsLabel } from '@icoach/accountBook/tables/OrderAllowanceRecordTable';
import useToggleDialog from '@util/hook/useToggleDialog';
import { dialogType } from '@icoach/accountBook/staticData';
import { isEqual } from '@util/utils';

const RemitAllowanceRecordTable = props => {
	const { className, rowsData = [], refresh } = props;
	const { openTarget, handleOpenDialog, handleCloseDialog, allowanceID, items } = useToggleDialog();
	const labelTitle = useRef(rowsLabel);
	return (
		<React.Fragment>
			<Tablenization cardProps={{ className: className }}>
				<Tablenization.TableRowHeader headerRow={labelTitle.current} />
				<Tablenization.TableRowBody headerRow={labelTitle.current} rowsData={rowsData} handleOpenDialog={handleOpenDialog} />
			</Tablenization>
			<RemitAllowanceVoidDialog open={isEqual(openTarget, dialogType.allowanceVoid)} allowanceID={allowanceID} items={items} onClose={handleCloseDialog} refresh={refresh} />
		</React.Fragment>
	);
};

export default RemitAllowanceRecordTable;
